'use strict';

var React = require('react');

var SvgReferralMajor = function SvgReferralMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 10c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10a9.944 9.944 0 0 1-4.924-1.305l-3.04 1.204c-1.209.459-2.393-.725-1.935-1.934l1.203-3.041a9.962 9.962 0 0 1-1.304-4.924Zm15.7-.645a1 1 0 0 1 0 1.4l-3 3a1 1 0 0 1-1.4 0 1 1 0 0 1 0-1.4l1.29-1.3h-6.59a1 1 0 0 1 0-2h6.59l-1.3-1.3a1 1 0 1 1 1.42-1.4l3 3h-.01Z"
  }));
};

exports.SvgReferralMajor = SvgReferralMajor;
